export enum Department {
  NEWS = 'News',
  RESEARCH = 'Research',
  COVENANTS = 'Covenants',
  MANAGEMENT = 'Management',
}

export interface AnalystPositionDto {
  department: Department;
  order: number | null;
}

export interface Analyst {
  tagId: string;
  displayName: string;
  initials: string;
  role: string | null;
  linkedInUrl: string | null;
  location: string | null;
  positions: AnalystPositionDto[];

  isActiveAuthor: boolean;
  displayOnTeamsPage: boolean;

  body?: string;
  imageUrl?: string;
  hasBio: boolean;
}
